<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppSingleSelect } from '@libs/ui';

import type { AlternativeTicketSuggestionActivitySegment } from '../../../models';
import ItineraryTimeline from '../ItineraryTimeline.vue';

import ActivityCardHeader from './ActivityCardHeader.vue';
import ActivityAlternativeProductCard from './ActivityAlternativeProductCard.vue';

const { t } = i18n.global;

interface AlternativeTicketSuggestionActivitySegmentProps {
  segment: AlternativeTicketSuggestionActivitySegment;
}

const props = defineProps<AlternativeTicketSuggestionActivitySegmentProps>();

interface AlternativeTicketSuggestionActivitySegmentEmits {
  (eventName: 'change-product'): void;
  (eventName: 'remove-activity'): void;
  (eventName: 'show-details'): void;
  (eventName: 'show-tickets'): void;
  (eventName: 'confirm-alternative'): void;
}

const emit = defineEmits<AlternativeTicketSuggestionActivitySegmentEmits>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="alternative-activity-segment"
  >
    <template #dropdown>
      <AppSingleSelect
        type="primary"
        :selected="{
          id: 1,
          label: t('planner.activity'),
          icon: 'activity',
        }"
        left-side-icon="activity"
        :options="[]"
        disabled
      />
    </template>
    <template #header>
      <ActivityCardHeader
        :print-mode="false"
        :date="props.segment.date"
        @remove="emit('remove-activity')"
      />
    </template>

    <template #content>
      <ActivityAlternativeProductCard
        :product-card-data="props.segment.productCardData"
        :context="props.segment.context"
        @show-details="emit('show-details')"
        @change-product="emit('change-product')"
        @show-tickets="emit('show-tickets')"
        @confirm-alternative="emit('confirm-alternative')"
      />
    </template>
  </ItineraryTimeline>
</template>
